// DAILY MEETING tab, same in the panel and employee sidebars.
// Competitor Analysis: only EDIT/DELETE here (ADD is in the Category and HOD panels).
// Influencer: one link (the EDIT / DELETE page, ADD is in the Category panel), so no sub-group.
const DAILY_MEETING = {
  title: "DAILY MEETING",
  subNav: [
    {
      title: "BATCHWISE COUNT",
      path: "cxoBatchwiseCount",
      cName: "sub-nav",
    },
    {
      title: "DATEWISE COUNT",
      path: "datewisecount",
      cName: "sub-nav",
    },
    {
      title: "LEAD ANALYSIS",
      path: "dailyLeadAnalysis",
      cName: "sub-nav",
    },
    {
      title: "REVENUE ANALYSIS",
      path: "dailyRevenueAnalysis",
      cName: "sub-nav",
    },
    {
      title: "USER ACTIVITY ANALYSIS",
      path: "userActivityAnalysis",
      cName: "sub-nav",
    },
    {
      title: "PAID ADS ANALYSIS",
      path: "dailyPaidAdsAnalysis",
      cName: "sub-nav",
    },
    {
      title: "YT STATS",
      subNav: [
        {
          title: "INSTA REELS",
          path: "instaReels",
          cName: "sub-nav",
        },
        {
          title: "LIVE YT VIDEO PERFORMANCE",
          path: "teacherPerformanceCat",
          cName: "sub-nav",
        },
        {
          title: "YT OFF TOPIC PERFORMANCE",
          path: "offTopicPerformance",
          cName: "sub-nav",
        },
      ],
    },
    {
      title: "COMPETITOR ANALYSIS",
      subNav: [
        {
          title: "LIVE VIDEO - EDIT/DELETE",
          path: "editLiveCompetitorAnalysis",
          cName: "sub-nav",
        },
        {
          title: "OFF TOPIC VIDEO - EDIT/DELETE",
          path: "editOffVideoCompetitorAnalysis",
          cName: "sub-nav",
        },
      ],
    },
    {
      title: "INFLUENCER ANALYSIS",
      path: "getInfluencer",
      cName: "sub-nav",
    },
  ],
};

export const CXOPanelSidebarData = [
  {
    title: "TRANSACTION DETAILS",
    subNav: [
      {
        title: "TOTAL REVENUE",
        path: "transactionDetails",
        cName: "sub-nav",
      },
      {
        title: "TRANSACTION EDUTECH",
        path: "transactionEdutech",
        cName: "sub-nav",
      },
      {
        title: "TRANSACTION EDUTECH STUDY MATERIAL",
        path: "transactionEdutechStudyMaterial",
        cName: "sub-nav",
      },
      {
        title: "TRANSACTION PUBLICATION",
        path: "transactionpublication",
        cName: "sub-nav",
      },
      {
        title: "PAYMENT IN PUBLICATION",
        path: "paymentPublication",
        cName: "sub-nav",
      },
    ],
  },

  
  {
    title: "USER DATA SEARCH",
    link: "userDataSearch",
  },

  {
    title: "CATEGORY",
    subNav: [
      {
        title: "INFLUENCER",
        path: "getInfluencer",
        cName: "sub-nav",
      },

      {
        title: "ADD RESULT",
        path: "resultCompilation",
        cName: "sub-nav",
      },
      {
        title: "STUDENT RESULT",
        path: "studentResult",
        cName: "sub-nav",
      },
      {
        title: "UPCOMING BATCH ANALYSIS",
        path: "UpcomingBatchAnalysis",
        cName: "sub-nav",
      },
      {
        title: "ALL RESULT",
        path: "allStudentResult",
        cName: "sub-nav",
      },
    ],
  },
  DAILY_MEETING,
  {
    title: "EMPLOYEE",
    subNav: [
      {
        title: "PAYROLL",
        path: "cxoPayroll",
        cName: "sub-nav",
      },
      {
        title: "EMPLOYEE DETAILS",
        path: "employeeDetails",
        cName: "sub-nav",
      },
      {
        title: "SAlARY ANALYSIS",
        path: "payRollCtc",
        cName: "sub-nav",
      },
    ],
  },

  {
    title: "REVENUE ANALYSIS",
    subNav: [
      {
        title: "SOURCE WISE ANALYSIS",
        path: "sourceWiseAnalysis",
        cName: "sub-nav",
      },
      {
        title: "PAYMENT TYPE WISE ANALYSIS",
        path: "paymentWiseAnalysis",
        cName: "sub-nav",
      },
      {
        title: "STATE WISE ANALYSIS",
        path: "stateWiseAnalysis",
        cName: "sub-nav",
      },

      // {
      //   title: "REVENUE PROJECTION",
      //   path: "RevenueProjection",
      //   cName: "sub-nav",
      // },
      {
        title: "REVENUE ANALYSIS",
        path: "cxoDashboard",
        cName: "sub-nav",
      },
      {
        title: "ALL EXAM WISE REVENUE NUMBER",
        path: "allExamWiseRevenue",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "COUPON TYPE ANALYSIS",
    link: "couponTypeAnalysis",
  },
  {
    title: "ADMISSION ANALYSIS",
    subNav: [
      {
        title: "BATCHWISE COUNT",
        path: "cxoBatchwiseCount",
        cName: "sub-nav",
      },
      {
        title: "DATEWISE COUNT",
        path: "datewisecount",
        cName: "sub-nav",
      },
      {
        title: "SECOND INSTALLMENT AMOUNT",
        subNav: [
          {
            title: "ASSURED REVENUE",
            path: "assuredRevenue",
            cName: "sub-nav",
          },
          {
            title: "SECOND INSTALLMENT DUE",
            path: "secondInstallmentDue",
            cName: "sub-nav",
          },
          {
            title: "SECOND INSTALLMENT PAID",
            path: "secondInstallmentPaid",
            cName: "sub-nav",
          },
        ],
      },
    ],
  },

  {
    title: "LEADS DETAILS",
    subNav: [
      {
        title: "ALL SOURCE DETAILS LEADS",
        path: "registereduser",
        cName: "sub-nav",
      },
      {
        title: "ALL SOURCE LEAD COUNTS",
        path: "allSourceLead",
        cName: "sub-nav",
      },
      {
        title: "WEBSITE/APP LEAD COUNT",
        path: "websiteLeadCount",
        cName: "sub-nav",
      },

      {
        title: "CLASSROOM LEADS",
        path: "classroomstudents",
        cName: "sub-nav",
      },
      {
        title: "HOME PAGE LEADS",
        path: "expertsupport",
        cName: "sub-nav",
      },
      {
        title: "SOURCE ANALYSIS",
        path: "leadAnalysis",
        cName: "sub-nav",
      },
      {
        title: "REFERENCE GENERATED",
        path: "referenceGenerated",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "LEAD ORDERS SEARCH",
    link: "leadOrderSearch",
  },
  {
    title: "WHATSAPP MESSAGE",
    subNav: [
      {
        title: "REGISTRATION CONFIGURATION",
        subNav: [
          {
            title: "ADD",
            path: "studentCouponAdd",
            cName: "sub-nav",
          },
          {
            title: "EDIT/DELETE",
            path: "studentCouponEdit",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "POST ADMISSION CONFIGURATION",
        subNav: [
          {
            title: "ADD",
            path: "addWPConfig",
            cName: "sub-nav",
          },
          {
            title: "EDIT/DELETE",
            path: "editWPConfig",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "MESSAGE DELIVERED STATUS",
        path: "messageDeliveredStatus",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "WHATSAPP MESSAGE ANALYSIS",
    link: "whatsappmessageAnalysis",
  },
  {
    title: "WHATSAPP DATA ANALYSIS",
    subNav: [
      {
        title: "WHATSAPP DATA SOURCE ANALYSIS",
        path: "WhatsappDataAnalysis",
        cName: "sub-nav",
      },
      {
        title: "WHATSAPP DATA STATE ANALYSIS",
        path: "WhatsappDataStateAnalysis",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "TEACHER DETAILS",
    subNav: [
      {
        title: "TEACHER PERFORMANCE",
        path: "teacherPerformance",
        cName: "sub-nav",
      },
      {
        title: "TEACHER TASK PLAN COMPLETE",
        path: "teacherTaskPlanComplete",
        cName: "sub-nav",
      },
      {
        title: "TEACHER TASK PLAN PENDING",
        path: "teacherTaskPlanPending",
        cName: "sub-nav",
      },
      {
        title: "TEACHER TASK PLAN NOT COMPLETED",
        path: "teacherTaskPlanNotCompleted",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "PERFORMANCE",
    subNav: [
      {
        title: "BDE Performance",
        path: "bdePerformance",
        cName: "sub-nav",
      },
      {
        title: "Sales Performance",
        path: "salesPerformance",
        cName: "sub-nav",
      },
      {
        title: "Category Performance",
        path: "categoryPerformance",
        cName: "sub-nav",
      },
      {
        title: "Social Media Performance",
        path: "socialMediaPerformance",
        cName: "sub-nav",
      },
      {
        title: "Youtube Target Performance",
        path: "youtubeTargetPerformance",
        cName: "sub-nav",
      },
    ],
  },

  {
    title: "REGISTER COUNT",
    link: "registerCount",
  },
  {
    title: "ACTIVE USER",
    link: "activeUser",
  },

  // {
  //   title: "BOARD MEETING",
  //   subNav: [
  //     {
  //       title: "EDUTECH",
  //       path: "boardMeetingEdutech",
  //       cName: "sub-nav",
  //     },
  //     {
  //       title: "PUBLICATION",
  //       path: "boardMeetingPublication",
  //       cName: "sub-nav",
  //     },
  //     {
  //       title: "LEADS",
  //       path: "boardMeetingLeads",
  //       cName: "sub-nav",
  //     },
  //   ],
  // },
  {
    title: "PACKAGE DETAILS",
    subNav: [
      {
        title: "EXTRA/OLD PACKAGE EXISTS",
        path: "oldPackageExist",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "REPORTS",
    link: "downloadReports",
  },

  {
    title: "TECHNICAL SUPPORT",
    link: "technicalsupport",
  },
  {
    title: "INFLUENCER PAYMENT",
    link: "influencerPayment",
  },
  {
    title: "Verify Referral Payment",
    link: "referralPayment",
  },
  {
    title: "SALES VP DASHBOARD",
    link: "salesVPDashboard",
  },
  {
    title: "ORDER ANALYSIS",
    subNav: [
      {
        title: "WELCOME",
        path: "orderAnalysis",
        cName: "sub-nav",
      },
      {
        title: "STUDENT 2nd",
        path: "studentType2",
        cName: "sub-nav",
      },
      {
        title: "STUDENT 3rd",
        path: "studentType3",
        cName: "sub-nav",
      },
      {
        title: "Extend",
        path: "extendOrderAnalysis",
        cName: "sub-nav",
      },
      {
        title: "Upgrade ",
        path: "upgradeOrderAnalysis",
        cName: "sub-nav",
      },
      // {
      //   title: "Student Extend Expired ",
      //   path: "studentExtendExpired",
      //   cName: "sub-nav",
      // },
      {
        title: "Cancel Payment Done",
        path: "cancelPaymentDone",
        cName: "sub-nav",
      },
      {
        title: "User Activity",
        path: "userActivity",
        cName: "sub-nav",
      },
      // {
      //   title: "Spin The Wheel",
      //   path: "spinTheWheel",
      //   cName: "sub-nav",
      // },
      // {
      //   title: "Birth Day List",
      //   path: "birthDayList",
      //   cName: "sub-nav",
      // },
      {
        title: "BirthDay Analysis",
        path: "birthDayAnalysis",
        cName: "sub-nav",
      },
      {
        title: "Add to Cart",
        path: "addToCart",
        cName: "sub-nav",
      },
      {
        title: "Add On Analysis",
        path: "addOnAnlaysis",
        cName: "sub-nav",
      },
      {
        title: "Cross Selling Analysis",
        path: "crossSellingAnalysis",
        cName: "sub-nav",
      },
      {
        title: "Cancelled Analysis",
        path: "cancelledAnalysis",
        cName: "sub-nav",
      },
      {
        title: "Source-Wise Analysis",
        path: "sourceWiseDataAnalysis",
        cName: "sub-nav",
      },
      {
        title: "Source-Wise Conversion Analysis",
        path: "sourceWiseConversionAnalysis",
        cName: "sub-nav",
      },
      {
        title: "7 Day Free Task Analysis",
        path: "sevenDayFreeTask",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "VIDEO DOWNLOADED",
    link: "videoDownloaded",
  },
  {
    title: "ACTIVITY DETAILS",
    subNav: [
      {
        title: "Paid Page Ananlysis",
        path: "paidPageAnalysis",
        cName: "sub-nav",
      },
      {
        title: "Free Page Ananlysis",
        path: "freePageAnalysis",
        cName: "sub-nav",
      },
      {
        title: "PAID ADS ANALYSIS",
        path: "paidAdsAnalysis",
        cName: "sub-nav",
      },
      {
        title: "DEMOGRAPHIC DATA ANALYSIS",
        path: "demoGraphicData",
        cName: "sub-nav",
      },
      // {
      //   title: "Free Page Ananlysis",
      //   path: "oldPackageExist",
      //   cName: "sub-nav",
      // },
      {
        title: "ORIGINAL SOURCE ANALYSIS",
        path: "originalSourceAnalysis",
        cName: "sub-nav",
      },
    ],
  },
  // {
  //   title: "CATEGORY WISE ANALYSIS",
  //   link: "categoryWiseAnalysis",
  // },
  {
    title: "STORY ANALYSIS",
    link: "storyAnalysis",
  },
  {
    title: "CATEGORY WISE ANALYSIS",
    subNav: [
      {
        title: "DAY WISE LEAD ANALYSIS",
        path: "categoryWiseAnalysis",
        cName: "sub-nav",
      },
      {
        title: "SOURCE SECTION WISE LEAD ANALYSIS",
        path: "sourceWiseLeadAnalysis",
        cName: "sub-nav",
      },
      {
        title: "STUDENT LEAD ANALYSIS",
        path: "studentDetails",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "TEACHER WISE ANALYSIS",
    link: "teacherWiseAnalysis",
  },
  {
    title: "USER ACTIVITY TRACKER",
    link: "userActivityTracker",
  },
  // {
  //   title: "Classroom Registration",
  //   link: "ClassroomRegistrationAnalysis",
  // },
  {
    title: "Classroom Registration",
    subNav: [
      {
        title: "Classroom Registration",
        path: "ClassroomRegistrationAnalysis",
        cName: "sub-nav",
      },
      {
        title: "Payment Done",
        path: "PaymentDone",
        cName: "sub-nav",
      },
      {
        title: "Upcoming Payment",
        path: "UpcomingPayment",
        cName: "sub-nav",
      },
    ],
  },
  // {
  //   title: "Push Notification Analysis",
  //   link: "pushNotificationAnalysis",
  // },
  // {
  //   title: "Mail Analysis",
  //   link: "mailCampaignAnalysis",
  // },
  {
    title: "REFUND PAYMENT",
    link: "cxoRefundPayment",
  },
  {
    title: "Funnel Analysis",
    link: "FunnelAnalysis",
  },
  {
    title: "Chat Analysis",
    link: "chatAnalysis",
  },
  {
    title: "Exam Analytics",
    link: "examAnalytics",
  },
  {
    title: "Insights",
    subNav: [
      {
        title: "Mail Analysis",
        path: "mailCampaignAnalysis",
        cName: "sub-nav",
      },
      {
        title: "Push Notification Analysis",
        path: "pushNotificationAnalysis",
        cName: "sub-nav",
      },
      {
        title: "Subscription Analysis",
        path: "subscriptionAnalysis",
        cName: "sub-nav",
      },
      {
        title: "Campaign Analysis",
        path: "campaignAnalysis",
        cName: "sub-nav",
      },
      {
        title: "Order Breakdown by Segment",
        path: "orderBreakdownbySegment",
        cName: "sub-nav",
      },
      {
        title: "Targeting Exam Analysis",
        path: "targetingExamAnalysis",
        cName: "sub-nav",
      },
      {
        title: "Book sales analysis",
        path: "BookSalesAnalysis",
        cName: "sub-nav",
      },
    ],
  },
   {
    title: "MOVEMENTS OF MEETING",
    subNav: [
      {
        title: "MOVEMENTS OF MEETING",
        path: "movementsOfMeeting",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editMovementsOfMeeting",
        cName: "sub-nav",
      },
    ],
  },
  

  // {
  //   title: "Subscription Analysis",
  //   link: "subscriptionAnalysis",
  // },
  // {
  //   title: "Campaign Analysis",
  //   link: "campaignAnalysis",
  // },
];

export const CXOEmpPanelSidebarData = [
  {
    title: "EMPLOYEE DETAILS",
    subNav: [
      {
        title: "Dashboard",
        path: "dashboard",
        cName: "sub-nav",
      },
      {
        title: "My Profile",
        path: "userProfile",
        cName: "sub-nav",
      },
      {
        title: "Policies",
        path: "policy",
        cName: "sub-nav",
      },
      {
        title: "KRA/KPI",
        path: "kraKpi",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "TRANSACTION DETAILS",
    subNav: [
      {
        title: "TOTAL REVENUE",
        path: "transactionDetails",
        cName: "sub-nav",
      },
      {
        title: "TRANSACTION EDUTECH",
        path: "transactionEdutech",
        cName: "sub-nav",
      },
      {
        title: "TRANSACTION EDUTECH STUDY MATERIAL",
        path: "transactionEdutechStudyMaterial",
        cName: "sub-nav",
      },
      {
        title: "TRANSACTION PUBLICATION",
        path: "transactionpublication",
        cName: "sub-nav",
      },
      {
        title: "PAYMENT IN PUBLICATION",
        path: "paymentPublication",
        cName: "sub-nav",
      },
    ],
  },

  {
    title: "USER DATA SEARCH",
    link: "userDataSearch",
  },

  {
    title: "CATEGORY",
    subNav: [
      {
        title: "INFLUENCER",
        path: "getInfluencer",
        cName: "sub-nav",
      },

      {
        title: "ADD RESULT",
        path: "resultCompilation",
        cName: "sub-nav",
      },
      {
        title: "STUDENT RESULT",
        path: "studentResult",
        cName: "sub-nav",
      },
      {
        title: "UPCOMING BATCH ANALYSIS",
        path: "UpcomingBatchAnalysis",
        cName: "sub-nav",
      },
      {
        title: "ALL RESULT",
        path: "allStudentResult",
        cName: "sub-nav",
      },
    ],
  },

  {
    title: "EMPLOYEE",
    subNav: [
      {
        title: "PAYROLL",
        path: "cxoPayroll",
        cName: "sub-nav",
      },
      {
        title: "EMPLOYEE DETAILS",
        path: "employeeDetails",
        cName: "sub-nav",
      },
      {
        title: "SAlARY ANALYSIS",
        path: "payRollCtc",
        cName: "sub-nav",
      },
    ],
  },

  {
    title: "REVENUE ANALYSIS",
    subNav: [
      {
        title: "SOURCE WISE ANALYSIS",
        path: "sourceWiseAnalysis",
        cName: "sub-nav",
      },
      {
        title: "PAYMENT TYPE WISE ANALYSIS",
        path: "paymentWiseAnalysis",
        cName: "sub-nav",
      },
      {
        title: "STATE WISE ANALYSIS",
        path: "stateWiseAnalysis",
        cName: "sub-nav",
      },

      // {
      //   title: "REVENUE PROJECTION",
      //   path: "RevenueProjection",
      //   cName: "sub-nav",
      // },
      {
        title: "REVENUE ANALYSIS",
        path: "dashboard",
        cName: "sub-nav",
      },
      {
        title: "ALL EXAM WISE REVENUE NUMBER",
        path: "allExamWiseRevenue",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "ADMISSION ANALYSIS",
    subNav: [
      {
        title: "BATCHWISE COUNT",
        path: "cxoBatchwiseCount",
        cName: "sub-nav",
      },
      {
        title: "DATEWISE COUNT",
        path: "datewisecount",
        cName: "sub-nav",
      },
      {
        title: "SECOND INSTALLMENT AMOUNT",
        subNav: [
          {
            title: "ASSURED REVENUE",
            path: "assuredRevenue",
            cName: "sub-nav",
          },
          {
            title: "SECOND INSTALLMENT DUE",
            path: "secondInstallmentDue",
            cName: "sub-nav",
          },
          {
            title: "SECOND INSTALLMENT PAID",
            path: "secondInstallmentPaid",
            cName: "sub-nav",
          },
        ],
      },
    ],
  },

  {
    title: "LEADS DETAILS",
    subNav: [
      {
        title: "ALL SOURCE DETAILS LEADS",
        path: "registereduser",
        cName: "sub-nav",
      },
      {
        title: "ALL SOURCE LEAD COUNTS",
        path: "allSourceLead",
        cName: "sub-nav",
      },
      {
        title: "WEBSITE/APP LEAD COUNT",
        path: "websiteLeadCount",
        cName: "sub-nav",
      },

      {
        title: "CLASSROOM LEADS",
        path: "classroomstudents",
        cName: "sub-nav",
      },
      {
        title: "HOME PAGE LEADS",
        path: "expertsupport",
        cName: "sub-nav",
      },
      {
        title: "SOURCE ANALYSIS",
        path: "leadAnalysis",
        cName: "sub-nav",
      },
      {
        title: "REFERENCE GENERATED",
        path: "referenceGenerated",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "LEAD ORDERS SEARCH",
    link: "leadOrderSearch",
  },

  {
    title: "WHATSAPP MESSAGE",
    subNav: [
      {
        title: "REGISTRATION CONFIGURATION",
        subNav: [
          {
            title: "ADD",
            path: "studentCouponAdd",
            cName: "sub-nav",
          },
          {
            title: "EDIT/DELETE",
            path: "studentCouponEdit",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "POST ADMISSION CONFIGURATION",
        subNav: [
          {
            title: "ADD",
            path: "addWPConfig",
            cName: "sub-nav",
          },
          {
            title: "EDIT/DELETE",
            path: "editWPConfig",
            cName: "sub-nav",
          },
        ],
      },
      {
        title: "MESSAGE DELIVERED STATUS",
        path: "messageDeliveredStatus",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "WHATSAPP MESSAGE ANALYSIS",
    link: "whatsappmessageAnalysis",
  },
  {
    title: "WHATSAPP DATA ANALYSIS",
    subNav: [
      {
        title: "WHATSAPP DATA SOURCE ANALYSIS",
        path: "WhatsappDataAnalysis",
        cName: "sub-nav",
      },
      {
        title: "WHATSAPP DATA STATE ANALYSIS",
        path: "WhatsappDataStateAnalysis",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "TEACHER DETAILS",
    subNav: [
      {
        title: "TEACHER PERFORMANCE",
        path: "teacherPerformance",
        cName: "sub-nav",
      },
      {
        title: "TEACHER TASK PLAN COMPLETE",
        path: "teacherTaskPlanComplete",
        cName: "sub-nav",
      },
      {
        title: "TEACHER TASK PLAN PENDING",
        path: "teacherTaskPlanPending",
        cName: "sub-nav",
      },
      {
        title: "TEACHER TASK PLAN NOT COMPLETED",
        path: "teacherTaskPlanNotCompleted",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "PERFORMANCE",
    subNav: [
      {
        title: "BDE Performance",
        path: "bdePerformance",
        cName: "sub-nav",
      },
      {
        title: "Sales Performance",
        path: "salesPerformance",
        cName: "sub-nav",
      },
      {
        title: "Category Performance",
        path: "categoryPerformance",
        cName: "sub-nav",
      },
      {
        title: "Social Media Performance",
        path: "socialMediaPerformance",
        cName: "sub-nav",
      },
      {
        title: "Youtube Target Performance",
        path: "youtubeTargetPerformance",
        cName: "sub-nav",
      },
    ],
  },

  {
    title: "REGISTER COUNT",
    link: "registerCount",
  },

  // {
  //   title: "BOARD MEETING",
  //   subNav: [
  //     {
  //       title: "EDUTECH",
  //       path: "boardMeetingEdutech",
  //       cName: "sub-nav",
  //     },
  //     {
  //       title: "PUBLICATION",
  //       path: "boardMeetingPublication",
  //       cName: "sub-nav",
  //     },
  //     {
  //       title: "LEADS",
  //       path: "boardMeetingLeads",
  //       cName: "sub-nav",
  //     },
  //   ],
  // },
  {
    title: "PACKAGE DETAILS",
    subNav: [
      {
        title: "EXTRA/OLD PACKAGE EXISTS",
        path: "oldPackageExist",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "REPORTS",
    link: "downloadReports",
  },

  {
    title: "TECHNICAL SUPPORT",
    link: "technicalsupport",
  },
  {
    title: "MOVEMENTS OF MEETING",
    subNav: [
      {
        title: "MOVEMENTS OF MEETING",
        path: "movementsOfMeeting",
        cName: "sub-nav",
      },
      {
        title: "EDIT/DELETE",
        path: "editMovementsOfMeeting",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "INFLUENCER PAYMENT",
    link: "influencerPayment",
  },
  {
    title: "SALES VP DASHBOARD",
    link: "salesVPDashboard",
  },
  {
    title: "ORDER ANALYSIS",
    subNav: [
      {
        title: "WELCOME",
        path: "orderAnalysis",
        cName: "sub-nav",
      },
      {
        title: "STUDENT 2nd",
        path: "studentType2",
        cName: "sub-nav",
      },
      {
        title: "STUDENT 3rd",
        path: "studentType3",
        cName: "sub-nav",
      },
      {
        title: "Extend",
        path: "extendOrderAnalysis",
        cName: "sub-nav",
      },
      {
        title: "Upgrade ",
        path: "upgradeOrderAnalysis",
        cName: "sub-nav",
      },
      // {
      //   title: "Student Extend Expired ",
      //   path: "studentExtendExpired",
      //   cName: "sub-nav",
      // },
      {
        title: "Cancel Payment Done",
        path: "cancelPaymentDone",
        cName: "sub-nav",
      },
      {
        title: "User Activity",
        path: "userActivity",
        cName: "sub-nav",
      },
      // {
      //   title: "Spin The Wheel",
      //   path: "spinTheWheel",
      //   cName: "sub-nav",
      // },
      // {
      //   title: "Birth Day List",
      //   path: "birthDayList",
      //   cName: "sub-nav",
      // },
      {
        title: "Add to Cart",
        path: "addToCart",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "ACTIVITY DETAILS",
    subNav: [
      {
        title: "Paid Page Ananlysis",
        path: "paidPageAnalysis",
        cName: "sub-nav",
      },
      {
        title: "PAID ADS ANALYSIS",
        path: "paidAdsAnalysis",
        cName: "sub-nav",
      },
      // {
      //   title: "Free Page Ananlysis",
      //   path: "oldPackageExist",
      //   cName: "sub-nav",
      // },
      {
        title: "ORIGINAL SOURCE ANALYSIS",
        path: "originalSourceAnalysis",
        cName: "sub-nav",
      },
    ],
  },
  // {
  //   title: "CATEGORY WISE ANALYSIS",
  //   link: "categoryWiseAnalysis",
  // },
  {
    title: "CATEGORY WISE ANALYSIS",
    subNav: [
      {
        title: "DAY WISE LEAD ANALYSIS",
        path: "categoryWiseAnalysis",
        cName: "sub-nav",
      },
      {
        title: "SOURCE SECTION WISE LEAD ANALYSIS",
        path: "sourceWiseLeadAnalysis",
        cName: "sub-nav",
      },
      {
        title: "STUDENT LEAD ANALYSIS",
        path: "studentDetails",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "USER ACTIVITY TRACKER",
    link: "userActivityTracker",
  },
  // {
  //   title: "Classroom Registration",
  //   link: "ClassroomRegistrationAnalysis",
  // },
  {
    title: "Classroom Registration",
    subNav: [
      {
        title: "Classroom Registration",
        path: "ClassroomRegistrationAnalysis",
        cName: "sub-nav",
      },
      {
        title: "Payment Done",
        path: "PaymentDone",
        cName: "sub-nav",
      },
      {
        title: "Upcoming Payment",
        path: "UpcomingPayment",
        cName: "sub-nav",
      },
    ],
  },
  {
    title: "Push Notification Analysis",
    link: "pushNotificationAnalysis",
  },
  {
    title: "Mail Analysis",
    link: "mailCampaignAnalysis",
  },
  {
    title: "REFUND PAYMENT",
    link: "cxoRefundPayment",
  },
  {
    title: "Chat Analysis",
    link: "chatAnalysis",
  },
  {
    title: "Exam Analytics",
    link: "examAnalytics",
  },
  {
    title: "Subscription Analysis",
    link: "subscriptionAnalysis",
  },
  {
    title: "Campaign Analysis",
    link: "campaignAnalysis",
  },
  DAILY_MEETING,
];
